import React, { Fragment, useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import NoCallNoShow from '../TermForms/NoCallNoShow';
import Quit from '../TermForms/Quit';
import NoCallNoShowFirst from '../TermForms/NoCallNoShowFirst';
import Other from '../TermForms/Other';
import './Termination.css';
import CbmContext from '../../Context/Cbm/cbmContext';
import { useFormSetup } from '../../hooks/useFormSetup';
import ValidationErrors from '../Utils/ValidationErrors';

const Termination = ({ setPayLoad, setFormError, errMsg }) => {
  const [queryParams] = useSearchParams();
  const [termForm] = useState(queryParams.get('termForm'));

  const cbmContext = useContext(CbmContext);
  const { portalUser, submittedData, errorCode } = cbmContext;
  const [termInfo, setTermInfo] = useState({
    employee: {
      employeeNumber: '',
      employeeFirst: '',
      employeeMiddle: '',
      employeeLast: '',
      employeeSecondLast: '',
    },
    quitReason: 'N/A',
    lastDayWorked: '',
    eligibleRehire: false,
    twoWeeksGiven: false,
    warningsGiven: false,
    termType: termForm,
    portalUser,
  });

  // Use unified form setup hook for validation, rehydration, and payload sync
  const { validationErrors, getFieldError } = useFormSetup({
    formName: 'termination',
    formData: termInfo,
    setFormData: setTermInfo,
    setPayLoad,
    setFormError,
    submittedData,
    errorCode,
  });

  const changeEmpInfo = (e) => {
    const { name, value } = e.target;
    let tempTermInfo = { ...termInfo };
    tempTermInfo.employee[name] = value;
    setTermInfo(tempTermInfo);
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, ' ', value);
    setTermInfo({ ...termInfo, [name]: value });
  };

  return (
    <Fragment>
      {errMsg && (
        <div className="error-message-container">
          <p className="error-message">{errMsg}</p>
          <ValidationErrors errors={validationErrors} />
        </div>
      )}
      {queryParams.get('termForm') === 'quit' && (
        <Quit
          changeEmpInfo={changeEmpInfo}
          onHandleChange={onHandleChange}
          termInfo={termInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      )}
      {queryParams.get('termForm') === 'noCall' && (
        <NoCallNoShow
          changeEmpInfo={changeEmpInfo}
          onHandleChange={onHandleChange}
          termInfo={termInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      )}
      {queryParams.get('termForm') === 'noShowFirstDay' && (
        <NoCallNoShowFirst
          changeEmpInfo={changeEmpInfo}
          onHandleChange={onHandleChange}
          termInfo={termInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      )}
      {queryParams.get('termForm') === 'Other' && (
        <Other
          changeEmpInfo={changeEmpInfo}
          onHandleChange={onHandleChange}
          termInfo={termInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      )}
    </Fragment>
  );
};

export default Termination;
